import type { PAGE_POSITIONS, PageType } from 'types';
import type { ProductListItemInternal } from 'types/capi/shared';

import FlameIcon from '~/assets/icons/Flame';
import CarouselScroller from '~/components/CarouselScroller';
import Image from '~/components/Image';
import NotificationTooltip from '~/components/NotificationTooltip';
import ProductCard from '~/components/ProductCard';

type Props = {
  allowNotifications: boolean;
  description: string;
  overrideInteractionPagePosition?: boolean;
  pagePosition: PAGE_POSITIONS;
  pageType: PageType;
  products: ProductListItemInternal[];
  showBackground: boolean;
  showIcon?: boolean;
  title: string;
};

export default function PopularReleasesCarousel({
  allowNotifications,
  description,
  overrideInteractionPagePosition = false,
  showIcon = true,
  pagePosition,
  pageType,
  products,
  showBackground,
  title
}: Props) {
  return (
    <div
      className={`relative w-full ${showBackground ? 'mb-4 py-6 md:py-10' : ''}`}
    >
      {showBackground && (
        <Image
          alt="sole-market-hub-sign-up-banner"
          src="https://cms-cdn.thesolesupplier.co.uk/2024/04/whats-hot-banner.jpg"
          className="absolute left-0 top-0 size-full object-cover brightness-75"
          loading="lazy"
          width={672}
          quality={100}
          responsiveOptions={{
            lg: { width: 1024 },
            md: { width: 768 },
            sm: { width: 672 },
            xl: { width: 1440 }
          }}
        />
      )}
      <div
        className={`content-width relative flex h-fit flex-col items-center justify-start gap-6 ${showBackground ? 'text-white' : ''}`}
      >
        <div className="flex w-full flex-col gap-2">
          <span className="flex w-full items-center justify-start gap-2">
            {showIcon && <FlameIcon />}
            <span
              className={pageType === 'plp' ? 'text-title-md' : 'text-title-xl'}
            >
              {title}
            </span>
          </span>
          <div className="flex flex-col justify-between gap-4 md:flex-row">
            <span className="text-sm font-normal leading-6">{description}</span>
            {allowNotifications && (
              <NotificationTooltip className="w-[42vw] md:w-[264px]" />
            )}
          </div>
        </div>
        <CarouselScroller slidesClassName="gap-2 md:gap-6">
          {products.map((product, productIndex) => (
            <ProductCard.Internal
              key={`product-${productIndex}`}
              product={product}
              padImage
              className="w-[42vw] flex-none md:w-[264px]"
              allowNotifications={allowNotifications}
              pageType={pageType}
              imageLoading="eager"
              cardSize="small"
              showNotificationCount={true}
              pagePosition={pagePosition}
              position={productIndex + 1}
              overrideInteractionPagePosition={overrideInteractionPagePosition}
            />
          ))}
        </CarouselScroller>
      </div>
    </div>
  );
}
